import React from 'react';

function CommonMistakes({ onRequestAssistance }) {
    return (
        <section className="information" id="common-mistakes">
            <div className="content">
                <h2>Common Mistakes to Avoid</h2>
                <p>
                    Applying for <span className="osap-highlight">OSAP</span> can be tricky, and small errors can lead to delays or even rejection of your application.
                </p>
                <ul>
                    <li><strong>Missing deadlines:</strong> Submitting your application late can delay your funding, leaving you struggling to cover tuition and expenses.</li>
                    <li><strong>Incomplete documentation:</strong> Failing to provide accurate income details or program information can result in your application being flagged or denied.</li>
                    <li><strong>Misunderstanding eligibility:</strong> Not knowing the specific requirements for your program or student status can lead to an unsuccessful application.</li>
                </ul>
                <p>
                    These mistakes can be costly, but they’re avoidable with the right guidance. To ensure a smooth process, <a href="#" onClick={onRequestAssistance}>request assistance</a> from experts who can help you navigate these challenges.
                </p>
            </div>
        </section>
    );
}

export default CommonMistakes;